module.exports = __webpack_public_path__ + "static/media/Iris Street, San Francisco, CA1.00e41b9d.jpg";